@switch (columnName) {
  @case ('arrivalDateTime') {
    {{ element.from | date: dateTimeFormat }}
  }
  @case ('departureDate') {
    {{ element.to | date: dateTimeFormat }}
  }
  @default {
    {{ element[columnName] }}
  }
}
